import Joi from 'joi';
import { objectSchemaOf } from '../helpers';
import type { RequestFieldKey } from './showKeyboardAction';
import { requestFieldKeySchema } from './showKeyboardAction';

export interface IShowKeyboardParams {
  conversationId: string;
  inputKey: RequestFieldKey;
  label: string;
  placeholder?: string;
  message?: string;
}

export const showKeyboardParamsSchema = objectSchemaOf<IShowKeyboardParams>({
  conversationId: Joi.string().required(),
  inputKey: requestFieldKeySchema.required(),
  label: Joi.string().required(),
  placeholder: Joi.string(),
  message: Joi.string(),
});
